import { push } from 'connected-react-router';

export default (errorPage, unrecoverableKey = 'unrecoverableError') => store => next => (action) => {
  if (action.error && action.meta && unrecoverableKey in action.meta && action.meta[unrecoverableKey]) {
    store.dispatch(push(errorPage));
  }

  return next(action);
};
